import EventBus from "../../../../util/EventBus";
import Applet from "../../Applet";
import EnlilDetailGoogleConfiguration from "../../../../components/EnlilDetailGoogleConfiguration";

class ETLGoogleConfigurationFormApplet extends Applet {
    state = {
        Name: "ETLGoogleConfigurationFormApplet",
        Actions: {
            View: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "Name",
                            },
                            {
                                id: "ServiceAccountEmail",
                            },
                            {
                                id: "ProjectID",
                            },
                            {
                                id: "Path",
                            }
                        ]
                    }
                ]
            },
            New: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "Name",
                            },
                            {
                                id: "ServiceAccountEmail",
                            },
                            {
                                id: "ProjectID",
                            },
                            {
                                id: "Path",
                            },
                            {
                                id: "PrivateKey",
                            }
                        ]
                    }
                ]
            },
            Edit: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "Name",
                            },
                            {
                                id: "ServiceAccountEmail",
                            },
                            {
                                id: "ProjectID",
                            },
                            {
                                id: "Path",
                            }
                        ]
                    }
                ]
            },
            Delete: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "Name",
                            },
                            {
                                id: "ServiceAccountEmail",
                            },
                            {
                                id: "ProjectID",
                            },
                            {
                                id: "Path",
                            }
                        ]
                    }
                ]
            }
        },
        Layout: {
            totalWidth: "36em",
        },
        Controls: {
            Name: {
                id: "Name",
                enterpriseComponentAttribute: "Name",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Name",
                    size: "small",
                    disabled: false,
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
            ServiceAccountEmail: {
                id: "ServiceAccountEmail",
                enterpriseComponentAttribute: "ServiceAccountEmail",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                    {
                        validator: "Required Pattern",
                        value: null,
                        errorText: "Invalid email address.",
                    }
                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Service Account Email",
                    size: "small",
                    disabled: false,
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
            ProjectID: {
                id: "ProjectID",
                enterpriseComponentAttribute: "ProjectID",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Project ID",
                    size: "small",
                    disabled: false,
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
            Path: {
                id: "Path",
                enterpriseComponentAttribute: "Path",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Path",
                    size: "small",
                    disabled: false,
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
            PrivateKey: {
                id: "PrivateKey",
                enterpriseComponentAttribute: "PrivateKey",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                ],
                csp: {
                    autoFocus: false,
                    multiline: true,
                    placeholder: null,
                    label: "Private Key",
                    size: "small",
                    disabled: false,
                    rows: 5
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
        }
    };

    cancel() {
        super.cancel();

        if (this.props.defaultAction === "Edit") {
            EventBus.components.emit("etl-google-configuration-form-edit-applet-cancel");
        } else {
            EventBus.components.emit("etl-google-configuration-form-edit-applet-cancel");
        }
    };

    setAction(action: string) {
        super.setAction(action);

        if (action === "Save Completed") {
            if (this.props.defaultAction === "Edit") {
                EventBus.components.emit("etl-google-configuration-form-edit-applet-save");
            } else {
                EventBus.components.emit("etl-google-configuration-form-edit-applet-save");
            }
        }
    };

    render() {
        return <EnlilDetailGoogleConfiguration applet={this}
                                layout={this.state.Layout}
                                controls={this.state.Controls}
                                actions={this.state.Actions}
                                title="Google Configuration"
                                enterpriseComponent={this.getEnterpriseComponent()}
                                action={this.props.defaultAction}
                                errorReportingMethod="RealTime" />;
    }
}

export default ETLGoogleConfigurationFormApplet